// orders/Search.js
// import React, { useState } from "react";
import "../../global.css";
// import { useNotification } from "../../context/NotificationContext";

export default function SearchTable({
  aggregators,
  onSearch,
  onAggregatorChange,
  searchValue,
  aggregatorValue,
}) {
  // const { showNotification } = useNotification();
  // const [isLoading, setIsLoading] = useState(false);

  // const handleRecoverUnread = async () => {
  //   try {
  //     setIsLoading(true);

  //     const res = await fetch(
  //       `${process.env.REACT_APP_BACKENDORDERURL}/gmail/recover-unread`,
  //       { method: "POST" }
  //     );

  //     const data = await res.json();

  //     showNotification(data.message || "Recovery started", "success");
  //   } catch (err) {
  //     showNotification("Failed to recover unread orders", "error");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  return (
    <div
      className="search-container"
      style={{
        display: "flex",
        gap: "2rem",
        flexWrap: "wrap",
        alignItems: "center",
        // justifyContent: "space-between",
        width: "100%",
      }}
    >
      <h3>Orders</h3>
      <select
        id="aggregatorFilter"
        className="search-bar"
        value={aggregatorValue || ""}
        onChange={(e) => onAggregatorChange(e.target.value)}
        style={{ minWidth: "70px" }}
      >
        <option value="">All Aggregators</option>
        {aggregators.map((agg) => (
          <option key={agg} value={agg}>
            {agg}
          </option>
        ))}
      </select>
      <input
        type="text"
        id="globalSearch"
        placeholder="Search..."
        className="search-bar"
        value={searchValue || ""}
        onChange={(e) => onSearch(e.target.value)}
        style={{ minWidth: "50px" }}
      />
      {/* <button
        className="btn btn-warning"
        onClick={handleRecoverUnread}
        disabled={isLoading}
        sx={{ minWidth: "30px" }}
      >
        Missed order
      </button> */}
    </div>
  );
}
